<template>
	<div>
		<div class="announce_div">
			<div class="announce_img">
				<img :src="announceImg">
			</div>
			<div class="announce_area">
				<marquee>{{announce}}
				</marquee>
			</div>
		</div>
		<card style="margin-bottom: 20px">
			<Row style="padding-top: 20px">
				<Col :xs="{ span: 12 }" :md="{ span: 6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">客户搜索</span>
					<Input v-model="name" placeholder="搜索系统内所有客户" />
				</div>
				</Col>
				<Col :xs="{ span: 12 }" :md="{ span: 6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">状态</span>
					<Select v-model="status"  clearable placeholder="状态" >
						<Option v-for="item in statusFilters" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
				</div>
				</Col>
				<Col :xs="{ span: 12 }" :md="{ span: 6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">星级</span>
					<Select v-model="start"  clearable placeholder="星级" >
						<Option v-for="item in starsFilters" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
				</div>
				</Col>
				<Col :xs="{ span: 12 }" :md="{ span: 6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">未跟进天数</span>
					<Input v-model="notFollowTimeValue"  placeholder="未跟进天数"
						style="width: 150px" />
				</div>
				</Col>
			</Row>
			<Row style="padding-top: 20px" >
				<Col :xs="{ span: 12 }" :md="{ span: 6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">申请时间</span>
					<DatePicker type="daterange" :value="apply_time" placeholder="申请时间" @on-change="applyTimeChange">
					</DatePicker>
				</div>
				</Col>
				<Col :xs="{ span: 12 }" :md="{ span: 6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">备注</span>
					<Input v-model="remark" placeholder="备注" />
				</div>
				</Col>
				<Col :xs="{ span: 12 }" :md="{ span: 6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon chaxun">跟进状态</span>
					<div class="input-group-addon my_client">
						<input type="checkbox" v-model="is_follow" checked="checked"
							/><span>未跟进</span>
					</div>
				</div>
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">排序方式</span>
					<Select v-model="orderBy" clearable placeholder="排序方式" >
						<Option v-for="item in sortLise" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
				</div>
				</Col>
			</Row>
			<Row style="padding-top: 20px">
				<Col :xs="{ span: 12 }" :md="{ span: 6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">备注时间</span>
					<DatePicker type="daterange" :value="updated_at" placeholder="备注时间" @on-change="updatedTimeChange">
					</DatePicker>
				</div>
				</Col>
				<Col :xs="{ span: 12 }" :md="{ span: 6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">重复申请时间</span>
					<DatePicker type="daterange" :value="re_time" placeholder="重复申请时间" @on-change="reTimeChange">
					</DatePicker>
				</div>
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 6, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">申请额度</span>
					<Input v-model="loan_money_min" placeholder="最低额度(万)" style="width: 100px;"  />
					<span class="add_title">--</span>
					<Input v-model="loan_money_max" placeholder="最高额度(万)" style="width: 100px;"  />
				</div>
				</Col>
			</Row>
			<Row style="padding-top: 20px">
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
					<div class="input-group">
						<span class="input-group-addon">媒体类型</span>
						<Select v-model="mediumType"  style="width:150px;" clearable placeholder="媒体类型">
							<Option value="1" >金掌柜平台</Option>
							<Option value="2" >第三方平台</Option>
						</Select>
					</div>
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }"
					v-if="this.userInfo.media_is_open == true">
				<div class="input-group">
					<span class="input-group-addon">来源</span>
					<Select v-model="media" clearable  style="width:200px" placeholder="媒体代码">
						<Option v-for="item in categoryList" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
				</div>
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
					<Button @click="mySearch" type="primary" >搜索</Button>
				</Col>
				
			</Row>
			<Row style="padding-top: 20px">
				<Col style="float: left">
				<Button @click="initSearch" type="primary" style="margin-left: 20px">重置刷新</Button>
				<Button @click="addClue" type="primary" style="margin-left: 20px">添加客户</Button>
				<Button @click="addPoolBatch" type="primary" style="margin-left: 20px">放入公共池</Button>
				<Button @click="goToSearchModal" type="primary" style="margin-left: 20px">系统客户搜索</Button>
				<Button @click="goToMyImportantClient" type="primary" style="margin-left: 20px">我的重要客户</Button>
				<Button @click="goToMemo" type="primary" style="margin-left: 20px">备忘提醒</Button>
				</Col>
			</Row>
			<div class="el-row"
				style="font-size: 12px;margin: 16px 0px;padding: 6px 20px;background: rgb(255, 237, 237);">
				<b>提示</b>：您当前有
				<Button @click="notFollowClient(1)"
					class="el-Button el-Button--default el-Button--mini is-disabled"><span>{{
            countData.not_follow_1
        }}</span></Button>位客户超过1天未跟进，
				<Button @click="notFollowClient(2)" class="el-Button el-Button--default el-Button--mini is-disabled"
					style="margin: 0px 2px">
					<!---->
					<!----><span>{{ countData.not_follow_3 }}</span>
				</Button>位客户超过3天未跟进，
				<Button @click="notFollowClient(3)" class="el-Button el-Button--default el-Button--mini is-disabled"
					style="margin: 0px 2px">
					<!---->
					<!----><span>{{ countData.not_follow_5 }}</span>
				</Button>位客户超过5天未跟进，
				<Button @click="notFollowClient(4)" class="el-Button el-Button--default el-Button--mini is-disabled"
					style="margin: 0px 2px">
					<!---->
					<!----><span>{{ countData.not_follow_7 }}</span>
				</Button>位客户超过7天未跟进； 其中超过1天未跟进的三星以上客户有
				<Button class="el-Button el-Button--default el-Button--mini is-disabled" @click="notFollowClient(5)"
					style="margin: 0px 2px">
					<!---->
					<!----><span>{{ countData.not_follow_1_3start }}</span>
				</Button>位。请注意及时跟进！
				<Button class="el-Button el-Button--text">
					<!---->
					<!----><span @click="initSearch">刷新</span>
				</Button>
			</div>
		</card>
		<div class="multiple" style="width: 100%">
			<Table :columns="columns" :data="datas" ref="table" :row-class-name="rowClassName" >
				<template slot-scope="{ row }" slot="name">
					<span v-if="menuName != 'client_search'">{{ row.name }}</span>
					<span v-if="menuName == 'client_search'">{{ row.name }}</span>
				</template>
				<template slot-scope="{ row }" slot="make_state">
					<img v-for="(item, index) in row.make_state" style="width: 20px; margin-top: 5px" :src="item" />
					<div v-if="row.make_state.length == 0">无</div>
				</template>
				<template slot-scope="{ row }" slot="loans_money">
					<span>{{ row.loans_money / 10000 }}万</span>
				</template>
				<template slot-scope="{ row }" slot="entrust">
					<div v-for="(item, index) in row.entrust" style="margin: 3px 0" :key="index">
						{{ item.content }} {{ item.created_at }}
					</div>
					<div v-if="row.entrust.length == 0">无</div>
				</template>
				<template slot-scope="{ row }" slot="operation">
					<div v-if="menuName != 'client_search'"
						style="display: flex; flex-direction: column; align-items: center">
						<Button @click.stop="edit" :data-id="row.id" :data-name="row.name" type="info">编辑客户</Button>
					</div>
					<div v-if="menuName == 'client_search'"
						style="display: flex; flex-direction: column; align-items: center">
						<span>{{ row.follow_name }}</span>
					</div>
				</template>
			</Table>
		</div>
		<div>
			<Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
				:current="page" @on-change="changePage" @on-page-size-change="changeSize" size="small" show-elevator />
		</div>
		<!-- 编辑客户 -->
		<div v-if="editDiv" style="background: #f9fafc">
			<Modal v-model="editModal" width="95%" title="" footer-hide :styles="editModalStyle">
				<NewEditClue @reloadData="getList" @beforeOne="beforeEditOne" @nextOne="nextEditOne" :id="clientId"
					ref="NewEditClue">
				</NewEditClue>
			</Modal>
		</div>
		<!-- 新增客户 -->
		<Modal v-model="addClientModal" width="45%" title="">
			<div class="flex flex_between" style="padding: 5px 30px">
				<label class="inline">姓名</label>
				<Input v-model="client.name" placeholder="请输入姓名" />
			</div>
			<div class="flex flex_between" style="padding: 5px 30px">
				<label class="inline">性别</label>
				<Select v-model="client.sex">
					<Option :value="1">男</Option>
					<Option :value="2">女</Option>
				</Select>
			</div>
			<div class="flex flex_between" style="padding: 5px 30px">
				<label class="inline">是否拓客</label>
				<Select v-model="client.is_introduce">
					<Option :value="1">拓客</Option>
					<Option :value="0">非拓客</Option>
				</Select>
			</div>
			<div class="flex flex_between" style="padding: 5px 30px">
				<label class="inline">电话号码</label>
				<Input v-model="client.phone" placeholder="请输入电话号码" />
			</div>
			<div class="flex flex_between" style="padding: 5px 30px">
				<label class="inline">城市</label>
				<Input v-model="client.city" placeholder="请输入城市" />
			</div>
			<div class="flex flex_between" style="padding: 5px 30px">
				<label class="inline">年龄</label>
				<Input v-model="client.age" placeholder="请输入年龄" />
			</div>
			<div class="flex flex_between" style="padding: 5px 30px">
				<label class="inline">贷款金额</label>
				<Input v-model="client.money" placeholder="请输入贷款金额" />
			</div>
			<div slot="footer">
				<Button type="text" @click="addClientModal = false">取消</Button>
				<Button type="primary" @click="addClient">确定</Button>
			</div>
		</Modal>

		<!-- 添加跟进记录 -->
		<Modal v-model="modal" width="1200" footer-hide>
			<quickEditClue @quickEditClient="quickEditClient" @reloadData="getList" @beforeOne="beforeOne"
				ref="quickEditClue" @nextOne="nextOne" :id="addRecordId"></quickEditClue>
		</Modal>
		<!-- 系统客户搜索 -->
		<Modal v-model="searchClientModal" width="1200">
			<Row style="padding-top: 20px">
				<Col :xs="{ span: 12 }" :md="{ span: 6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">客户搜索</span>
					<Input v-model="searchAllName" placeholder="搜索系统内所有客户" />
				</div>
				</Col>
				<Col :xs="{ span: 12 }" :md="{ span: 6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<Button class="ivu-btn-circle" type="primary" @click="clientSearch">搜索</Button>
				</Col>
			</Row>
			<Row style="padding-top: 20px;" v-if="userInfo.role_type == 4">
				<Col style="float: left;">
				<Button @click="giveOutModal = true" type="success" style="margin-left: 20px;">批量分配</Button>
				<Button @click="transferModal = true" type="success" style="margin-left: 20px;">批量转移</Button>
				<Button @click="delClient" type="success" style="margin-left: 20px;">删除客户</Button>
				</Col>
			</Row>
			<span>(一次搜索最多搜索出10条，请尽量精准搜索)</span>
			<Row style="padding-top: 20px">
				<Table :columns="searchColumns" :data="searchDatas" ref="searchTable">
					<template slot-scope="{ row }" slot="entrust">
						<div v-for="(item, index) in row.entrust" style="margin: 3px 0" :key="index">
							{{ item.content }} {{ item.created_at }}
						</div>
						<div v-if="row.entrust.length == 0">无</div>
					</template>
					<template slot-scope="{ row }" slot="loans_money">
						<span>{{ row.loans_money / 10000 }}万</span>
					</template>
				</Table>
			</Row>
		</Modal>
		<!-- 选择分配人 -->
		<Modal v-model="giveOutModal" width="650" title="选择分配人">
			<div class="multiple" style="margin-top: 0">
				<div class="child-div in-block">分配给</div>
				<Checkbox :value="checkAll" @click.prevent.native="handleCheckAll" :indeterminate="indeterminate">
					<span>全选</span>
				</Checkbox>
				<CheckboxGroup v-model="giveOutUid" @on-change="checkAllGroupChange">
					<Checkbox v-for="item in userList" :label="item.id"><span>{{item.name}}</span></Checkbox>
				</CheckboxGroup>
			</div>
			<div slot="footer">
				<Button type="primary" @click="giveOutBatch">确定</Button>
			</div>
		</Modal>
		<!-- 添加跟进记录 -->
		<Modal v-model="memoModal" width="1200" footer-hide>
			<Memo @quickEditClient="quickEditClient" ref="Memo" :id="addRecordId"></Memo>
		</Modal>
	</div>
</template>
<script>
	import quickEditClue from "./quickEditClue.vue";
	import EditClue from "./EditClue.vue";
	import NewEditClue from "./NewEditClue.vue";
	import Memo from "./Memo.vue";
	import {
		mapMutations,
		mapActions,
		mapGetters
	} from "vuex";
	import {
		getList,
		addSea,
		addPool,
		allUnlock,
		lock,
		giveOut,
		getCount,
		transferUser,
		addClient,
		saveClient,
		delClient
	} from "@/api/client";
	import {
		getUserList,
		getMyClientTips,
		getAnnounce,
		getTeamList,
		getDepartmentList,
	} from "@/api/user";
	import {
		getAllMediumCode
	} from "../../api/runSet";

	export default {
		name: "myclient",
		components: {
			quickEditClue,
			EditClue,
			NewEditClue,
			Memo
		},
		props: {
			needInitSearch: {
				type: Boolean,
			},
			menuName: {
				type: String,
			},
			openMenuName: {
				type: String,
			},
		},
		data() {
			return {
				clientTips: {
					title: "",
					clientId: 0,
					type: 0,
					name: "",
					plat_at: "",
				},
				searchClientModal: false,
				clientTipsModal: false,
				notFollowTime: false,
				screeningSwitch: false,
				memoModal: false,
				apply_time: [],
				join_time: [],
				updated_at: [],
				re_time: [],
				followTimes: 0,
				followUid: [],
				followDepartment: [],
				loanMoney: 0,
				start: [],
				status: [],
				is_follow: false,
				is_house: "",
				is_car: "",
				is_accumulation: "",
				is_social_security: "",
				is_weilidai: "",
				is_salary: "",
				is_credit_card: "",
				is_pay_taxes: "",
				orderBy: "",
				loan_money_min: '',
				loan_money_max: '',
				indeterminate: true,
				checkAll: false,
				addClientModal: false,
				editModalStyle: {
					top: "7%",
					background: "#f9fafc",
					"border-radius": "15px",
				},
				client: {
					name: "",
					phone: "",
					sex: "",
					city: "",
					age: "",
					loans_money: "",
					is_introduce: 1,
				},
				editDiv: false,
				editModal: false,
				search_myself: true,
				search_again: true,
				clientId: 0,
				pageSize: 10,
				pageSizeOpts: [10, 50, 100, 200, 500],
				announce: "",
				announceImg: require("../../assets/images/announce.png"),
				countDataImg: {
					exclamatory: require("../../assets/images/exclamatory.png"),
					refresh: require("../../assets/images/refresh.png"),
				},
				countData: {
					soon_collect: "**",
					un_lock: "**",
					untreated: "**",
					not_follow_5: "**",
					not_follow_3: "**",
					not_follow_1: "**",
					not_follow_1_start: "**",
				},
				giveOutId: 0,
				giveOutUid: [],
				giveOutModal: false,
				transferModal: false,
				addRecordId: 0,
				foldShow: false,
				modal: false, //添加跟进记录
				media: [], //媒体代码
				apply: [], //申请条件
				count: 0,
				page: 1,
				name: "",
				remark: "",
				menu: "myclient",
				timeDimension: [],
				timePeriod: 0,
				notFollowTimeValue: "",
				notFollowClickStatus: false,
				call_tag: [],
				isComment: 0,
				userList: [],
				is_offer: [],
				makeState: [],
				clientType: [],
				timePeriodDate: [],
				categoryList: [],
				oldDatas: [],
				teamList: [],
				departmentList: [],
				datas: [],
				mediumType:'',
				searchDatas: [],
				options1: {
					shortcuts: [{
							text: "1 month",
							value() {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
								return [start, end];
							},
						},
						{
							text: "Yesterday",
							value() {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
								return [start, end];
							},
						},
						{
							text: "1 month",
							value() {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
								return [start, end];
							},
						},
					],
				},
				statusFilters: [{
						label: "未处理",
						value: "1",
					},
					{
						label: "待跟进",
						value: "2",
					},
					{
						label: "邀约中",
						value: "3",
					},
					{
						label: "上门未签约",
						value: "6",
					},
					{
						label: "已签约",
						value: "7",
					},
					{
						label: "进件中",
						value: "8",
					},
					{
						label: "银行拒绝",
						value: "9",
					},
					{
						label: "已回款",
						value: "13",
					},
					{
						label: "资质不符",
						value: "14",
					},
					{
						label: "捣乱申请",
						value: "15",
					},
					{
						label: "外地申请",
						value: "16",
					},
					{
						label: "重复申请",
						value: "17",
					},
				],
				starsFilters: [{
						value: 0,
						label: "0星",
					},
					{
						value: 1,
						label: "1星",
					},
					{
						value: 2,
						label: "2星",
					},
					{
						value: 3,
						label: "2星+",
					},
					{
						value: 4,
						label: "3星",
					},
					{
						value: 5,
						label: "4星",
					},
				],
				followTimesfilters: [{
						value: 1,
						label: "0次",
					},
					{
						value: 2,
						label: "1-3次",
					},
					{
						value: 3,
						label: "4-10次",
					},
					{
						value: 4,
						label: "11-20次",
					},
					{
						value: 5,
						label: "20次以上",
					},
				],
				conditionLise: [{
						value: 0,
						label: "无",
					},
					{
						value: 1,
						label: "有",
					},
				],
				sortLise: [{
						value: 1,
						label: '申请时间近到远'
					},
					{
						value: 2,
						label: '申请时间远到近'
					},
					{
						value: 3,
						label: '备注时间近到远'
					},
					{
						value: 4,
						label: '备注时间远到近'
					},
					{
						value: 5,
						label: '分配时间近到远'
					},
					{
						value: 6,
						label: '分配时间远到近'
					}
				],
				columns: [{
						type: "selection",
						width: 40,
						align: "center",
					},
					{
						title: "操作",
						slot: "operation",
						width: 50,
					},
					{
						title: "客户",
						slot: "name",
						width: 80,
					},
					{
						"title": "客户id",
						"key": "id",
						"width": 80
					},	
					{
						title: "手机",
						key: "phone",
						width: 80,
					},
					{
						title: "性别",
						key: "sex_name",
						width: 30,
					},
					{
						title: "星级",
						key: "start_name",
						width: 60,
						filters: [{
								value: 0,
								label: "0星",
							},
							{
								value: 1,
								label: "1星",
							},
							{
								value: 2,
								label: "2星",
							},
							{
								value: 3,
								label: "2星+",
							},
							{
								value: 4,
								label: "3星",
							},
							{
								value: 5,
								label: "4星",
							},
						],
						filterMultiple: false,
						filterRemote(value, row) {
							this.mySearchByStart(value);
						},
					},
					{
						title: "状态",
						key: "status_name",
						filters: [{
								label: "未处理",
								value: "1",
							},
							{
								label: "待跟进",
								value: "2",
							},
							{
								label: "邀约中",
								value: "3",
							},
							{
								label: "上门未签约",
								value: "6",
							},
							{
								label: "已签约",
								value: "7",
							},
							{
								label: "进件中",
								value: "8",
							},
							{
								label: "银行拒绝",
								value: "9",
							},
							{
								label: "已回款",
								value: "13",
							},
							{
								label: "资质不符",
								value: "14",
							},
							{
								label: "捣乱申请",
								value: "15",
							},
							{
								label: "外地申请",
								value: "16",
							},
							{
								label: "重复申请",
								value: "17",
							},
						],
						filterMultiple: false,
						filterRemote(value, row) {
							this.mySearchByStatus(value);
						},
						width: 60,
					},
					{
						title: "需求额度",
						slot: "loans_money",
						width: 70,
					},
					{
						title: "跟进记录",
						// "key": "entrust",
						slot: "entrust",
						width: 220,
					},
					{
						title: "申请时间",
						key: "applied_at",
						width: 100,
					},
					{
						title: "最后跟进时间",
						key: "updated_at",
						width: 100,
					},
					{
						title: "媒体代码",
						key: "media_name",
						width: 80,
					},
				],
				columnsCopy: [{
						type: "selection",
						width: 40,
						align: "center",
					},
					{
						title: "操作",
						slot: "operation",
						width: 50,
					},
					{
						title: "客户",
						slot: "name",
						width: 80,
					},
					{
						"title": "客户id",
						"key": "id",
						"width": 80
					},	
					{
						title: "手机",
						key: "phone",
						width: 80,
					},
					{
						title: "性别",
						key: "sex_name",
						width: 30,
					},
					{
						title: "星级",
						key: "start_name",
						width: 60,
						filters: [{
								value: 0,
								label: "0星",
							},
							{
								value: 1,
								label: "1星",
							},
							{
								value: 2,
								label: "2星",
							},
							{
								value: 3,
								label: "2星+",
							},
							{
								value: 4,
								label: "3星",
							},
							{
								value: 5,
								label: "4星",
							},
						],
						filterMultiple: false,
						filterRemote(value, row) {
							this.mySearchByStart(value);
						},
					},
					{
						title: "状态",
						key: "status_name",
						filters: [{
								label: "未处理",
								value: "1",
							},
							{
								label: "待跟进",
								value: "2",
							},
							{
								label: "邀约中",
								value: "3",
							},
							{
								label: "上门未签约",
								value: "6",
							},
							{
								label: "已签约",
								value: "7",
							},
							{
								label: "进件中",
								value: "8",
							},
							{
								label: "银行拒绝",
								value: "9",
							},
							{
								label: "已回款",
								value: "13",
							},
							{
								label: "资质不符",
								value: "14",
							},
							{
								label: "捣乱申请",
								value: "15",
							},
							{
								label: "外地申请",
								value: "16",
							},
							{
								label: "重复申请",
								value: "17",
							},
						],
						filterMultiple: false,
						filterRemote(value, row) {
							this.mySearchByStatus(value);
						},
						width: 60,
					},
					{
						title: "需求额度",
						slot: "loans_money",
						width: 70,
						filters: [{
								value: 1,
								label: "1000以下",
							},
							{
								value: 2,
								label: "1千-1万",
							},
							{
								value: 3,
								label: "1万-2万",
							},
							{
								value: 4,
								label: "2万-3万",
							},
							{
								value: 5,
								label: "3万以上",
							},
						],
						filterMultiple: false,
						filterRemote(value, row) {
							this.mySearchByMoney(value);
						},
					},
					{
						title: "跟进记录",
						// "key": "entrust",
						slot: "entrust",
						width: 220,
					},
					{
						title: "申请时间",
						key: "applied_at",
						width: 100,
					},
					{
						title: "最后跟进时间",
						key: "updated_at",
						width: 100,
					},
					{
						title: "媒体代码",
						key: "media_name",
						width: 80,
					},
				],
				searchColumns: [{
						type: "selection",
						width: 40,
						align: "center",
					},
					{
						title: "跟进人",
						key: "follow_name",
						width: 50,
					},
					{
						title: "客户",
						key: "name",
						width: 80,
					},
					{
						"title": "客户id",
						"key": "id",
						"width": 80
					},	
					{
						title: "城市",
						key: "city",
						width: 80,
					},
					{
						title: "手机",
						key: "phone",
						width: 80,
					},
					{
						title: "性别",
						key: "sex_name",
						width: 30,
					},
					{
						title: "星级",
						key: "start_name",
						width: 60,
					},
					{
						title: "状态",
						key: "status_name",
						width: 60,
					},
					{
						title: "需求额度",
						slot: "loans_money",
						width: 70,
					},
					{
						title: "跟进记录",
						// "key": "entrust",
						slot: "entrust",
						width: 220,
					},
					{
						title: "申请时间",
						key: "applied_at",
						width: 100,
					},
					{
						title: "最后跟进时间",
						key: "updated_at",
						width: 100,
					},
				],
				memorandum: false,
				memorandumColumns: [{
						type: "selection",
						width: 40,
						align: "center",
					},
					{
						title: "备忘提醒时间",
						key: "operation",
						width: 50,
					},
					{
						title: "备忘姓名",
						key: "name",
						width: 80,
					},
					{
						title: "备忘内容",
						key: "phone",
						width: 80,
					},
					{
						title: "状态",
						key: "phone",
						width: 80,
					},
				],
				searchAllName: "",
			};
		},
		computed: {
			...mapGetters(["token", "remarksSaveStatus", "isRefreshGetListStatus", "userInfo"]),
			remarksSaveStatus() {
				return this.$store.state.app.remarksSaveStatus;
			},
			isRefreshGetListStatus() {
				return this.$store.state.app.remarksSaveStatus;
			}
		},
		created: function() { //这里是定时器
			setInterval(this.timer, 3600000);
		},
		watch: {
			$route(to, from) {
				console.log(to)
			},
			remarksSaveStatus() {
				this.getList();
			},

		},
		mounted: function() {
			this.userDisplayTable();
			this.getAnnounce();
			this.loadData();
			this.getCount();
			this.getList();
		},
		methods: {
			...mapActions(["handleLogOut", "getUserInfo"]),
			timer: function() { //写成timer()也可
				this.getAnnounce(); //每小时更新公告
			},
			async getAnnounce() {
				let that = this;
				var data = {
					token: this.token
				};
				let res = await getAnnounce(that, data);
				if (res.code == 1) {
					var announceList = res.data.announceList
					var ann_length = announceList.length
					announceList.forEach((item, index, announceList) => {
						//执行代码
						if (ann_length == index + 1) {
							that.announce = that.announce + JSON.parse(item.ext_info).notice_msg
						} else {
							that.announce = that.announce + JSON.parse(item.ext_info).notice_msg + '~~~~~'
						}

					})
				}
			},
			async myTips() {
				let that = this;
				var data = {
					token: this.token,
				};
				let res = await getMyClientTips(that, data);
				if (res.code == 1) {
					that.clientTipsModal = true;
					that.clientTips = res.data;
				}
			},
			rowClassName(row, index) {
				if (row.is_updated >= 0 && row.re != 1) {
					return "table-blue-row";
				} else if (row.re == 1 && row.status == 17) {
					return "table-yellow-row";
				} else {
					return "table-black-row";
				}
			},
			changeSwitch(status) {
				this.screeningSwitch = status;
			},
			mySearchByFollow(followUid) {
				this.followUid = followUid;
				this.page = 1;
				this.getList();
			},
			mySearchByDepartment(followDepartment) {
				this.followDepartment = followDepartment;
				this.page = 1;
				this.getList();
			},
			mySearchByMoney(loanMoney) {
				this.loanMoney = loanMoney[0];
				this.page = 1;
				this.getList();
			},
			mySearchByContact(call_tag) {
				this.call_tag = call_tag;
				this.page = 1;
				this.getList();
			},
			mySearchByStatus(status) {
				this.status = status;
				this.page = 1;
				this.getList();
			},
			mySearchByStart(start) {
				this.start = start;
				this.page = 1;
				this.getList();
			},
			mySearchByCar(is_car) {
				this.is_car = is_car;
				this.page = 1;
				this.getList();
			},
			mySearchByHouse(is_house) {
				this.is_house = is_house;
				this.page = 1;
				this.getList();
			},
			mySearchByAccumulation(is_accumulation) {
				this.is_accumulation = is_accumulation;
				this.page = 1;
				this.getList();
			},
			mySearchBySocial(is_social_security) {
				this.is_social_security = is_social_security;
				this.page = 1;
				this.getList();
			},
			mySearchByWeilidai(is_weilidai) {
				this.is_weilidai = is_weilidai;
				this.page = 1;
				this.getList();
			},
			mySearchBySalary(is_salary) {
				this.is_salary = is_salary;
				this.page = 1;
				this.getList();
			},
			mySearchBySort(orderBy) {
				this.orderBy = orderBy;
				this.page = 1;
				this.getList();
			},
			mySearchByCreditCard(is_credit_card) {
				this.is_credit_card = is_credit_card;
				this.page = 1;
				this.getList();
			},
			mySearchByPayTaxes(is_pay_taxes) {
				this.is_pay_taxes = is_pay_taxes;
				this.page = 1;
				this.getList();
			},
			mySearch() {
				this.page = 1;
				//this.menu = 'client_search';
				this.getList();
			},
			addRecordClick(e) {
				let id = e.currentTarget.dataset.id;
				this.oldDatas = this.datas;
				this.addRecordId = id;
				this.modal = true;
			},
			timePeriodDateChange(e) {
				this.timePeriodDate = e;
				this.mySearch();
			},
			applyTimeChange(e) {
				this.apply_time = e;
			},
			updatedTimeChange(e) {
				this.updated_at = e;
			},
			reTimeChange(e) {
				this.re_time = e;
			},
			joinTimeChange(e) {
				this.join_time = e;
			},
			async loadData() {
				let that = this;
				var data = {
					token: this.token,
					only_customer: 1,
				};
				let res = await getAllMediumCode(that, data);
				if (res.code == 1) {
					that.categoryList = res.data.list;
				}
				var data = {
					token: that.token,
					getSelf: 1,
				};
				res = await getTeamList(that, data);
				if (res.code == 1) {
					that.userList = res.data.list;
					that.columns[1].filters = res.data.list;
					that.teamList = res.data.list;
				}
				res = await getDepartmentList(that, data);
				if (res.code == 1) {
					that.departmentList = res.data.list;
				}
			},
			async getCount() {
				let that = this;
				var data = {
					token: this.token,
				};
				let res = await getCount(that, data);
				if (res.code == 1) {
					that.$Message.success("获取成功");
					that.countData = res.data;
				}
			},
			notFollowClient(type) {
				let that = this;
				that.initSearch();
				that.notFollowClickStatus = true;
				if (type == 1) {
					that.notFollowTimeValue = 1; 

				} else if (type == 2) {
					that.notFollowTimeValue = 3;
				} else if (type == 3) {
					that.notFollowTimeValue = 5;
				} else if (type == 4) {
					that.notFollowTimeValue = 7;
				} else if (type == 5) {
					that.notFollowTimeValue = 3;
					that.start = [4,5];
				}
				that.getList();
			},
			initSearch() {
				console.log(this.userInfo)
				this.name = "";
				this.timeDimension = [];
				this.timePeriod = 0;
				this.notFollowTime = false;
				this.isComment = 0;
				this.page = 1;
				this.search_myself = true;
				this.search_again = true;
				this.menu = "myclient";
				this.apply = [];
				this.media = [];
				this.start = [];
				this.status = [];
				this.remark = "";
				this.call_tag = [];
				this.is_offer = [];
				this.clientType = [];
				this.timePeriodDate = [];
				this.apply_time = [];
				this.updated_at = [];
				this.re_time = [];
				this.join_time = [];
				this.notFollowTimeValue = "";
				this.is_house = "";
				this.is_car = "";
				this.is_accumulation = "";
				this.is_social_security = "";
				this.is_weilidai = "";
				this.is_salary = "";
				this.is_follow = false;
				this.is_credit_card = "";
				this.is_pay_taxes = "";
				this.followUid = "";
				this.followDepartment = "";
				this.orderBy = "";
				this.searchAllName = "";
				this.notFollowClickStatus = false;
				this.loan_money_min = '';
				this.loan_money_max = '';
				this.mediumType = '';
				this.getList();
				this.getCount();
			},
			userDisplayTable() {
				// type: 4 分公司负责人   5 区长
				if (this.userInfo.media_is_open !== true) {
					//此处判断不用用户类型是否有有对应的列权限
					this.columns = this.columns.filter((col) => col.key !== "media_name");
				} else {
					this.columns = this.columnsCopy;
				}
			},
			changeSize(e) {
				this.pageSize = e;
				this.getList();
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			async getList() {
				let that = this;
				var data = this.$data;
				data.limit = this.pageSize;
				data.token = this.token;
				data.page = this.page;
				let res = await getList(that, data);
				that.datas = res.data.list;
				for (var i = 0; i < that.datas.length; i++) {
					if (that.datas[i].is_lock == "1") {
						that.datas[i]["_disabled"] = true;
					}
				}
				that.count = res.count;
				that.getUserInfo();
				that.getCount();
			},
			async getSearchList() {
				let that = this;
				var data = {};
				data.menu = "all_search";
				data.token = this.token;
				data.searchAllName = this.searchAllName;
				let res = await getList(that, data);
				that.searchDatas = res.data.list;
				for (var i = 0; i < that.datas.length; i++) {
					if (that.datas[i].is_lock == "1") {
						that.datas[i]["_disabled"] = true;
					}
				}
				that.count = res.count;
				that.getUserInfo();
			},
			clientSearch() {
				this.getSearchList();
			},
			addClue() {
				let that = this;
				this.addClientModal = true;
			},
			goToSearchModal() {
				this.searchClientModal = true;
			},
			goToMemo() {
				this.memoModal = true;
			},
			goToMyImportantClient() {
				this.$router.push({
					name: "ImportantClient",
					params: {
						type: 1,
					},
				});
			},
			addClient() {
				let that = this;
				this.throttle(async function() {
					let data = {
						token: that.token,
						data: that.client,
					};
					let res = await addClient(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.addClientModal = false;
						that.getList();
					}
				}, 500);
			},
			edit(e) {
				let that = this;
				let id = e.id || e.currentTarget.dataset.id;
				let name = e.name || e.currentTarget.dataset.name;
				this.$nextTick(function() {
					/*
					  that.oldDatas = that.datas;
					  that.editModal = true;
					  */
					this.$router.push({
						name: "newEditClue",
						params: {
							id: id,
							name: name,
							data: that.datas,
						},
					});
				});
			},
			handleCheckAll() {
				if (this.indeterminate) {
					this.checkAll = false;
				} else {
					this.checkAll = !this.checkAll;
				}
				this.indeterminate = false;

				if (this.checkAll) {
					for (let i in this.userList) {
						this.giveOutUid.push(this.userList[i].id);
					}
				} else {
					this.giveOutUid = [];
				}
			},
			checkAllGroupChange(data) {
				if (data.length === 3) {
					this.indeterminate = false;
					this.checkAll = true;
				} else if (data.length > 0) {
					this.indeterminate = true;
					this.checkAll = false;
				} else {
					this.indeterminate = false;
					this.checkAll = false;
				}
			},
			clickGiveOut(e) {
				let that = this;
				this.giveOutId = e.currentTarget.dataset.id;
				that.giveOutModal = true;
			},
			giveOut() {
				let that = this;
				let ids = that.giveOutId;
				let data = {
					ids: ids,
					uid: that.giveOutUid,
					token: that.token,
				};
				that.throttle(async function() {
					let res = await giveOut(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.giveOutModal = false;
						that.getList();
					}
				}, 2000);
			},
			giveOutBatch() {
				let that = this;
				let selectTion = this.$refs["searchTable"].getSelection();
				let ids = [];
				selectTion.forEach(function(e) {
					ids.push(e.id);
				});
				let data = {
					ids: ids,
					uid: that.giveOutUid,
					token: that.token,
				};
				that.throttle(async function() {
					let res = await giveOut(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.giveOutModal = false;
						that.getSearchList();
					}
				}, 2000);
			},
			transferBatch() {
				let that = this;
				let selectTion = this.$refs["searchTable"].getSelection();
				let ids = [];
				selectTion.forEach(function(e) {
					ids.push(e.id);
				});
				let data = {
					ids: ids,
					uid: that.giveOutUid,
					token: that.token,
				};
				that.throttle(async function() {
					let res = await transferUser(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.transferModal = false;
						that.getSearchList();
					}
				}, 2000);
			},
			allUnlock() {
				let that = this;
				let selectTion = this.$refs["table"].getSelection();
				let ids = [];
				selectTion.forEach(function(e) {
					ids.push(e.id);
				});
				this.$Modal.confirm({
					title: "确认批量解锁吗？",
					onOk: async () => {
						let res = await allUnlock(that, {
							token: that.token,
							ids: ids,
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							//that.getList();
						}
					},
				});
			},
			delClient() {
				let that = this;
				let selectTion = this.$refs["searchTable"].getSelection();
				let ids = [];
				selectTion.forEach(function(e) {
					ids.push(e.id);
				});
				this.$Modal.confirm({
					title: "确认批量删除客户吗？",
					onOk: async () => {
						let res = await delClient(that, {
							token: that.token,
							id: ids,
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.getSearchList();
						}
					},
				});
			},
			addPoolBatch() {
				let that = this;
				let selectTion = this.$refs["table"].getSelection();
				let ids = [];
				selectTion.forEach(function(e) {
					ids.push(e.id);
				});
				this.$Modal.confirm({
					title: "确认批量加入公共池吗？",
					onOk: async () => {
						let res = await addPool(that, {
							token: that.token,
							id: ids,
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.getList();
						}
					},
				});
			},
			addSea(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				this.$Modal.confirm({
					title: "确认加入公海吗？",
					onOk: async () => {
						let res = await addSea(that, {
							token: that.token,
							id: id,
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.getList();
						}
					},
				});
			},
			addPool(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				this.$Modal.confirm({
					title: "确认加入公共池吗？",
					onOk: async () => {
						let res = await addPool(that, {
							token: that.token,
							id: id,
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.getList();
						}
					},
				});
			},
			async getTipsList(e) {
				let that = this;
				var data = {};
				data.menu = e.currentTarget.dataset.type;
				data.token = this.token;
				data.limit = 10;
				let res = await getList(that, data);
				that.datas = res.data.list;
			},
			async lock(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				let res = await lock(that, {
					token: that.token,
					id: id,
				});
				if (res.code == 1) {
					that.$Message.success(res.msg);
					that.getList();
				}
			},
			quickEditClient() {
				this.clientId = this.addRecordId;
				this.addRecordId = 0;
				this.modal = false;
				this.editDiv = true;
				this.$nextTick(function() {
					this.editModal = true;
				});
			},
			beforeEditOne() {
				let that = this;
				let item = that.findBeforeArr(that.oldDatas, "id", that.clientId);
				this.$refs.NewEditClue.phoneShow = false;
				if (item == false) {
					that.$Message.error("此页没有更多了");
					return;
				}
				that.clientId = item.id;
			},
			nextEditOne() {
				let that = this;
				let item = that.findNextArr(that.oldDatas, "id", that.clientId);
				this.$refs.NewEditClue.phoneShow = false;
				if (item == false) {
					that.$Message.error("此页没有更多了");
					return;
				}
				that.clientId = item.id;
			},
			beforeOne() {
				let that = this;
				let item = that.findBeforeArr(that.oldDatas, "id", that.addRecordId);
				this.$refs.quickEditClue.$refs.AddRecord.phoneShow = false;
				if (item == false) {
					that.$Message.error("此页没有更多了");
					return;
				}
				that.addRecordId = item.id;
			},
			nextOne() {
				let that = this;
				let item = that.findNextArr(that.oldDatas, "id", that.addRecordId);
				this.$refs.quickEditClue.$refs.AddRecord.phoneShow = false;
				if (item == false) {
					that.$Message.error("此页没有更多了");
					return;
				}
				that.addRecordId = item.id;
			},
		},
	};
</script>
<style scoped lang="less">

	/*栅格表开始*/
	.selectdiv .panel-body {
		padding: 20px 10;
		width: 100%;
		display: inline-block;
	}

	.selectdiv .btn {
		border-radius: 2px;
		margin: 5px 5px;
	}

	.team_btn1_rf {
		margin-top: 5px;
	}

	.rili_out {
		height: 36px;
		float: right;
		position: relative;
	}

	.rili_out .main_data {
		position: absolute;
		left: 0;
		top: 40px;
		z-index: 99;
		background: #ffffff;
		padding: 10px;
		border-radius: 4px;
		border: 1px #dddddd solid;
	}

	.rili_out .prompt {
		position: absolute;
		right: 4px;
		top: 4px;
		width: 8px;
		height: 8px;
		background: red;
		border-radius: 50%;
		border: 1px #ffffff solid;
	}

	.rili_out .btn_closerl {
		position: absolute;
		right: -10px;
		top: -10px;
		cursor: pointer;
	}

	#lk_content .callrecord {
		min-width: 1400px;
	}

	.callrecord-top {
		color: #ffffff;
		background-color: #db5a63;
	}

	#lk_content {
		width: 100%;
	}

	.callrecord .acco {
		cursor: pointer;
		color: red;
	}

	.callrecord .next2 {
		cursor: pointer;
		color: #8b0000;
	}

	#lk_content .callrecord-top .tit7 {
		width: 300px;
	}

	#lk_content .callrecord-top .tit15 {
		width: 120px;
	}

	#lk_content .callrecord-top .tit16 {
		width: 120px;
	}
</style>
<style scoped lang="less">
	.input-group .chaxun {
		padding: 6px;
	}

	.input-group .my_client {
		height: 30px;
		background: none;
		border-left: 1px #cccccc solid;
		padding: 6px 0;
	}

	.p {
		color: #409eff;
	}

	.form-list .info-inline .name {
		float: left;
		line-height: 38px;
		background: #f0f0f0;
		border-right: 1px solid #ddd;
		padding: 0 18px;
		border-top-left-radius: 4px;
		border-bottom-left-radius: 4px;
	}

	.form-list {
		width: 100%;
		display: inline-block;
		clear: both;
		padding: 8px 0;
	}

	.form-list .info-inline {
		width: 16%;
		height: 40px;
		float: left;
		margin: 7px 0.5%;
	}

	.form-list .bor-al,
	.form-list .bor-at {
		border: 1px solid #ddd;
		border-radius: 4px;
		width: 49%;
		float: left;
	}

	.form-list .bor-al,
	.form-list .bor-at {
		border: 1px solid #ddd;
		border-radius: 4px;
		width: 49%;
		float: left;
	}

	.form-list .info-inline .right {
		overflow: auto;
		position: relative;
	}

	.form-list .mar-let {
		margin-left: 2%;
	}

	.hong {
		color: #f56171;
		font-weight: bold;
		cursor: pointer;
	}

	.lan {
		color: #124386;
		font-weight: bold;
		cursor: pointer;
	}

	.sousuo {
		width: 100%;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	/deep/ .ivu-modal-content {
		background-color: #f9fafc;
	}

	/deep/ .ivu-table-header thead tr th {
		text-align: center !important;
	}

	/deep/ .ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	/deep/ .ivu-table table {
		width: 100% !important;
	}

	.green-bg {
		background: #18bc9c;
	}

	.blue-bg {
		background: #54a1f3;
	}

	.person {
		font-size: 14px;
		color: white;
		border-radius: 50%;
		width: 22px;
		height: 20px;
	}

	.in-block {
		display: inline-block;
	}

	.count_tips {
		color: rgb(0, 0, 0);
		justify-content: center !important;
		background: rgb(229, 245, 253);
		width: 1400px;
		margin: 0 auto;
		/* padding: 5px; */
		line-height: 35px;
		height: 35px;
	}

	.count_tips_img {
		width: 15px;
		height: 15px;
		vertical-align: middle;
		margin-right: 5px;
		margin-bottom: 3px;
	}

	.announce_div {
		position: relative;
		background-color: #f2f2f2;
		color: #e8410b;
		margin-bottom: 20px;
	}

	.announce_img {
		position: absolute;
		left: 4px;

		img {
			width: 20px;
			height: 20px;
			margin-top: 5px;
		}
	}

	.announce_area {
		margin-left: 25px;
		overflow: hidden;

		marquee {
			font-size: 20px;
			margin-top: 5px;
		}
	}

	.inline {
		display: inline-block;
		width: 30%;
	}

	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #ff6699;
	}

	/deep/ .ivu-table .table-yellow-row td {
		color: #aaaa00;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}

	/deep/ .client_name {
		display: inline-block;
		margin: 0 4px;
		color: #85c7ff;
	}
</style>
